import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './styles/provision-location';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import { translate } from 'react-i18next';

class ProvisionLocation extends React.Component {

  render() {
    const {
      t,
      customer,
      location,
      onCustomer,
      onLocation,
      customers,
      locations,
      disabled
    } = this.props;
    const getFieldProps = (value, fn) => ({
      value: value || '',
      onChange: (event) => fn(event.target.value)
    });
    return (
      <React.Fragment>
        <div className={classes.titleContainer}>
          <h6 className={classes.title}>{t('provisionLocation.title')}</h6>
        </div>
        <Row>
          <Col md={3}>
            <FormGroup>
              <Label for="provision_customer">{t('provisionLocation.customerLabel')}</Label>
              <Input
                type="select"
                name="provision_customer"
                id="provision_customer"
                disabled={disabled}
                {...getFieldProps(customer, onCustomer)}
              >
                <option value="" disabled>{t('provisionLocation.customerPlaceholder')}</option>
                {
                  customers
                    .map(
                      ({ name, uuid }, index) => <option value={uuid} key={index}>{name}</option>
                    )
                }
              </Input>
            </FormGroup>
          </Col>
          <Col md={1} className={classes.orContainer}>
            {t('provisionLocation.orLabel')}
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label for="provision_location">{t('provisionLocation.locationLabel')}</Label>
              <Input
                type="select"
                name="provision_location"
                id="provision_location"
                disabled={disabled}
                {...getFieldProps(location, onLocation)}
              >
                <option value="" disabled>{t('provisionLocation.locationPlaceholder')}</option>
                {
                  locations
                    .map(
                      ({ name, uuid }, index) => <option value={uuid} key={index}>{name}</option>
                    )
                }
              </Input>
            </FormGroup>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

}

ProvisionLocation.propTypes = {
  customer: PropTypes.string,
  location: PropTypes.string,
  onCustomer: PropTypes.func.isRequired,
  onLocation: PropTypes.func.isRequired,
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  disabled: PropTypes.bool
};

export default translate(['pending'])(ProvisionLocation);


// WEBPACK FOOTER //
// ./src/views/pending-product-instance/provision-location.js